import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'unh-filter-bottomsheet-header',
  templateUrl: './filter-bottomsheet-header.component.html',
  styleUrls: ['./filter-bottomsheet-header.component.scss'],
})
export class FilterBottomsheetHeaderComponent implements OnInit {
  @Input() args: { label: string; icon: string };
  @Input() icon: string;

  constructor() {}

  ngOnInit(): void {}
}
